'use strict';
module.exports = require('../../full/instance/entries');
